module.exports = __webpack_public_path__ + "media/nivel0.78896c43.png";